import { AbstractControl } from '@angular/forms';

export class VisumErfassungComponentBase {
  errorClassRequired(ctrl: AbstractControl): boolean {
    return !!ctrl && (ctrl.dirty || ctrl.touched) && ctrl.errors != null;
  }

  enableOrDisableControlWithTimeout(enable: boolean, crtl: AbstractControl): void {
    // FIXME Ohne setTimeout() haben enable() und disable() (manchmal!) keine Auswirkung
    // Erklärung zum Fix könnten die Infos aus
    // https://blog.angular-university.io/how-does-angular-2-change-detection-really-work/
    // liefern.
    if (crtl) {
      setTimeout(() => {
        if (enable) {
          crtl.enable();
        } else {
          crtl.disable();
        }
      }, 0);
    }
  }

  /**
   * This method enables/ disables the delivered 'crtl' synchronously. In some cases the synchronous way is required for example if a FormGroup is
   * displayed based on a previous selection of another FormGroup. The asynchronous way can cause a problem if the values are written before the
   * FormGroup is displayed.
   * <b>This method just marks itself and all ancestors (default) and emits and event (default)</b>
   *
   * @param enable flag whether control should be enabled/ disabled
   * @param crtl to be enabled/ disabled
   */
  enableOrDisableControlsSynchronously(enable: boolean, ctrl: AbstractControl): void {
    if (enable) {
      ctrl.enable();
    } else {
      ctrl.disable();
    }
  }
}
